
import {fromJS,mergeDeep,merge} from 'immutable';
import { 
  GET_MENU,
  CIERRA_MENU,
} from '../actions'


const initialHeader = {
  opciones:[],
  flias:[], 
  refresca:0,
  user:null
}

const header = (state = initialHeader, action) => {

  const estadoNuevo = Object.assign({}, state);
  const datosNuevo = fromJS(estadoNuevo)

  switch (action.type) {
  
    case GET_MENU :
      var menu_temp=[]
      var flias_temp=[]
      var rubro_temp={}
      var rubro_act=0
      action.categorias.forEach(function(doc) {
        var data_temp=doc.data()
        if(data_temp.rubro.id!=rubro_act){
          if(rubro_act!=0){
            menu_temp.push(rubro_temp)
          }
          rubro_act=data_temp.rubro.id
          rubro_temp={
            id:data_temp.rubro.id,
            nombre:data_temp.rubro.nombre,
            categorias:[]
          }
          rubro_temp.categorias.push({id:doc.id,nombre:data_temp.nombre,img:data_temp.img,xtra:data_temp.xtra,descripcion:data_temp.descripcion})
        }else{
          rubro_temp.categorias.push({id:doc.id,nombre:data_temp.nombre,img:data_temp.img,xtra:data_temp.xtra,descripcion:data_temp.descripcion})
        }
        flias_temp.push({ id: doc.id, rubro_nombre: data_temp.rubro.nombre, nombre: data_temp.nombre, img: data_temp.img, xtra: data_temp.xtra, descripcion: data_temp.descripcion, venta_online: data_temp.venta_online})
      });
      //console.log(menu_temp)

      menu_temp.push(rubro_temp)

      const opcionesNew = datosNuevo.updateIn(['opciones'],value => menu_temp)
      const fliasNew = opcionesNew.updateIn(['flias'],value => flias_temp)
      return fliasNew.toJSON()

    case CIERRA_MENU :
     var newState = Object.assign({}, state);
     newState.refresca=state.refresca+1
     return newState;
    
    default:  
      return state
  }
}

export default header


// WEBPACK FOOTER //
// ./src/reducers/header.js